import {Component, Input, OnChanges} from '@angular/core';
import {Relation} from '../../../relation/shared/relation';
import { MatTooltip } from '@angular/material/tooltip';


@Component({
    selector: 'uf-core-relation',
    template: `<span [matTooltip]="tooltipText" [matTooltipDisabled]="tooltipDisabled">{{displayName}}</span>`,
    imports: [MatTooltip]
})
export class CoreRelationComponent implements OnChanges {
  @Input()
  relation: Relation;

  displayName: string;
  tooltipText = '';

  ngOnChanges(): void {
    if (this.relation) {
      if (this.relation.companyname) {
        this.displayName = this.relation.companyname;
        this.tooltipText = this.getFullname();
      } else {
        this.displayName = this.getFullname();
        this.tooltipText = '';
      }
    }
  }

  public get tooltipDisabled(): boolean {
    return !this.tooltipText;
  }

  public getFullname(): string {
    const parts: string[] = [];
    if (this.relation.title) {
      parts.push(this.relation.title);
    }
    if (this.relation.firstname) {
      parts.push(this.relation.firstname);
    }
    if (this.relation.infix) {
      parts.push(this.relation.infix);
    }
    if (this.relation.familyname) {
      parts.push(this.relation.familyname);
    }
    return parts.join(' ');
  }

}
